import { ARTICLES_LIMIT } from '../../utils/constants';
import {
    FETCH_ARTICLES_RETREAT_REQUEST,
    FETCH_ARTICLES_RETREAT_SUCCESS,
    FETCH_ARTICLES_RETREAT_FAILURE,
    FETCH_ARTICLES_RETREAT_CLEAN_UP,
    UPDATE_RETREAT_PAGE_START_PARAM,
} from '../constants/retreatTypes';

const initialState = {
    loading: false,
    articles: [],
    error: '',
    start: 0,
};

const articlesRetreatReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ARTICLES_RETREAT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_ARTICLES_RETREAT_SUCCESS:
            return {
                loading: false,
                articles: [...state.articles, ...action.payload.articles],
                error: '',
                start: state.start,
            };
        case FETCH_ARTICLES_RETREAT_FAILURE:
            return {
                loading: false,
                article: null,
                error: action.payload,
            };
        case FETCH_ARTICLES_RETREAT_CLEAN_UP:
            return {
                articles: [],
            };
        case UPDATE_RETREAT_PAGE_START_PARAM:
            return {
                ...state,
                start: state.start + ARTICLES_LIMIT,
            };
        default:
            return state;
    }
};

export default articlesRetreatReducer;
